import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "src/core/shared/api/config.api";
import useAxios from "src/core/shared/hooks/useAxios";
import cacheMinutesToMilliseconds from "src/library/utils/time-helpers/cache-minutes-to-milliseconds";

type ProductsEndpointConfig = {
  LIST_SUPPLIERS: EndpointConfig<
    void,
    ISupplier[]
  >;
};

const BASE_URL = `${process.env.REACT_APP_API_URL}/core/suppliers`;

const requests: RequestConfig<ProductsEndpointConfig> = {
  LIST_SUPPLIERS: () => ({
    url: `${BASE_URL}`,
    method: "GET",
    cache: {
      clearOnError: true,
      maxAge: cacheMinutesToMilliseconds(60)
    }
  })
};

export interface ISupplier {
  id: number;
  // display name of supplier
  name: string;
  // unique identifier for supplier
  slug: string;
  // settings used for backend processes so not typed here
  settings?: Record<string, unknown>;
  createdAt: Date;
  updatedAt: Date;
}

export const useSuppliersApi: UseApiRequest<ProductsEndpointConfig> = name => useAxios(requests[ name ], name);
